// extracted by mini-css-extract-plugin
export default {"disableLink":"En-z"};